import { Request } from '../models/request.model';

export const MOCK_REQUESTS: Request[] = [
  {
    id: '1',
    requestNumber: 'REQ-2024-001',
    description: 'Leaky faucet in kitchen needs repair',
    status: 'pending',
    clientId: 'client1',
    providerBusinessId: 'business1',
    providerBusinessName: 'Plumbing Services Inc',
    type: 'plumbing',
    createdOn: new Date('2024-01-15T10:30:00Z').getTime(),
    agentId: 'agent1',
    agentName: 'John Smith',
    clientName: 'Building Resident',
    providerName: 'Plumbing Services Inc',
    providerLogo: 'assets/images/provider1.png',
    dateCreated: '15 Jan 2024 - 10:30 AM',
    agent: 'John Smith',
    unreadMessages: 2,
  },
  {
    id: '2',
    requestNumber: 'REQ-2024-002',
    description: 'Elevator is not working properly',
    status: 'in_progress',
    clientId: 'client2',
    providerBusinessId: 'business2',
    providerBusinessName: 'Elevator Maintenance Co',
    type: 'elevator',
    createdOn: new Date('2024-01-14T08:15:00Z').getTime(),
    agentId: 'agent2',
    agentName: 'Mike Johnson',
    clientName: 'Building Manager',
    providerName: 'Elevator Maintenance Co',
    providerLogo: 'assets/images/provider2.png',
    dateCreated: '14 Jan 2024 - 08:15 AM',
    agent: 'Mike Johnson',
    unreadMessages: 5,
  },
  {
    id: '3',
    requestNumber: 'REQ-2024-003',
    description: 'AC unit is not cooling properly',
    status: 'completed',
    clientId: 'client3',
    providerBusinessId: 'business3',
    providerBusinessName: 'HVAC Solutions',
    type: 'hvac',
    createdOn: new Date('2024-01-10T16:45:00Z').getTime(),
    agentId: 'agent3',
    agentName: 'Sarah Wilson',
    clientName: 'Office Tenant',
    providerName: 'HVAC Solutions',
    providerLogo: 'assets/images/provider1.png',
    dateCreated: '10 Jan 2024 - 04:45 PM',
    agent: 'Sarah Wilson',
    unreadMessages: 0,
  },
  {
    id: '4',
    requestNumber: 'REQ-2024-004',
    description: 'Door lock needs replacement',
    status: 'pending',
    clientId: 'client4',
    providerBusinessId: 'business4',
    providerBusinessName: 'Security Services',
    type: 'security',
    createdOn: new Date('2024-01-17T09:00:00Z').getTime(),
    agentId: 'agent4',
    agentName: 'Tom Brown',
    clientName: 'Apartment Resident',
    providerName: 'Security Services',
    providerLogo: 'assets/images/provider2.png',
    dateCreated: '17 Jan 2024 - 09:00 AM',
    agent: 'Tom Brown',
    unreadMessages: 1,
  },
  {
    id: '5',
    requestNumber: 'REQ-2024-005',
    description: 'Garbage disposal needs repair',
    status: 'cancelled',
    clientId: 'client5',
    providerBusinessId: 'business5',
    providerBusinessName: 'Kitchen Repair Co',
    type: 'plumbing',
    createdOn: new Date('2024-01-13T13:20:00Z').getTime(),
    agentId: 'agent5',
    agentName: 'Lisa Davis',
    clientName: 'Restaurant Owner',
    providerName: 'Kitchen Repair Co',
    providerLogo: 'assets/images/provider1.png',
    dateCreated: '13 Jan 2024 - 01:20 PM',
    agent: 'Lisa Davis',
    unreadMessages: 0,
  },
];
